export const getDashboardItems = state => state.dashboard.items;
